/* eslint-disable camelcase */
import { useState } from 'react';
import { Card, Form, Col, Button } from 'react-bootstrap';
import { toast } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { loaderActions } from '../../features/Loader/LoaderSlice';
import API from '../../Services/API';

function ChangePassword() {
  const dispatch = useDispatch();
  const username = useSelector((state) => state.auth.username);
  const [user, setUser] = useState({
    old_password: '',
    newPassword: '',
    confirmPassword: ''
  });

  const { old_password, new_password, confirmPassword } = user;

  const onChange = (e) => setUser({ ...user, [e.target.name]: e.target.value });

  const changePassword = async () => {
    if (old_password === '' || new_password === '' || confirmPassword === '') {
      toast.error('All fields are required', { id: 'change-password' });
    } else if (!/^(?=.{6,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W)/.test(new_password)) {
      toast.error('Please enter a valid password', { id: 'change-password' });
    } else if (old_password === new_password) {
      toast.error('New Password cannot be same as Current Password', { id: 'change-password' });
    } else if (new_password !== confirmPassword) {
      toast.error('New Password and Confirm Password do not match', { id: 'change-password' });
    } else {
      await dispatch(loaderActions.show());
      try {
        await API().patch(`/evp-users/change_password`, {
          email: username,
          old_password,
          new_password
        });
        setUser({
          old_password: '',
          new_password: '',
          confirmPassword: ''
        });
        toast.success('Password successfully', { id: 'change-password' });
        await dispatch(loaderActions.hide());
      } catch (error) {
        toast.error(error.response.data, { id: 'change-password' });
        await dispatch(loaderActions.hide());
      }
    }
  };

  return (
    <>
      <Card className="p-4 ">
        <div className="text-center"></div>
        <Card.Body className="p-4">
          <Card.Title>
            <i className="feather icon-lock mt-2" /> &nbsp; Change Password
          </Card.Title>

          <Form.Group as={Col} controlId="old_password" className={'mt-4'}>
            <Form className="label">Current Password</Form>
            <Form.Control
              className="login_form mt-2"
              as="input"
              type="password"
              placeholder={'enter current password'}
              required
              name="old_password"
              value={old_password}
              onChange={onChange}
            />
          </Form.Group>
          <Form.Group as={Col} controlId="new_password" className={'mt-4'}>
            <Form className="label">New Password</Form>
            <Form.Control
              className="login_form mt-2"
              as="input"
              type="password"
              placeholder={'enter new password'}
              required
              name="new_password"
              value={new_password}
              onChange={onChange}
            />
            <Form.Text className="text-muted mt-2">
              Password should have at least 8 characters, 1 lower case, 1 upper case, 1 special
              character and 1 number
            </Form.Text>
          </Form.Group>
          <Form.Group as={Col} controlId="cPassword" className={'mt-4'}>
            <Form className="label">Confirm New Password</Form>
            <Form.Control
              className="login_form mt-2"
              as="input"
              type="password"
              placeholder={'Enter new password again'}
              required
              name="confirmPassword"
              value={confirmPassword}
              onChange={onChange}
            />
          </Form.Group>
          <div className="mt-4 px-3" style={{ width: '100%' }}>
            <Button
              size="small"
              className="btn btn-primary"
              onClick={changePassword}
              style={{
                borderRadius: '5px'
              }}
            >
              Reset Password
            </Button>
          </div>
        </Card.Body>
      </Card>
    </>
  );
}

export default ChangePassword;
